/* Enhance native contact controls; the form and anchors work without JavaScript. */
(() => {
  if (window.cmPartnersReady) return;
  window.cmPartnersReady = true;

  const selectTopic = (section, topic) => {
    const select = section.querySelector('[data-cm-partner-select]');
    if (!select || !topic) return false;
    const option = Array.from(select.options).find(item => item.dataset.cmPartnerOption === topic);
    if (!option) return false;
    select.value = option.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  };

  const selectFromHash = () => {
    let topic;
    try {
      topic = decodeURIComponent(window.location.hash.slice(1));
    } catch (_) {
      return;
    }
    document.querySelectorAll('[data-cm-partners]').forEach(section => selectTopic(section, topic));
  };

  const initialize = () => {
    document.querySelectorAll('[data-cm-partners]').forEach(section => {
      if (section.dataset.cmPartnerReady === 'true') return;
      section.dataset.cmPartnerReady = 'true';
      section.addEventListener('click', event => {
        const link = event.target.closest('[data-cm-partner-topic]');
        if (!link || !section.contains(link)) return;
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (!selectTopic(section, link.dataset.cmPartnerTopic)) return;
        // Leave the ordinary anchor navigation intact, then place keyboard focus
        // at the start of the form without undoing the anchor's scroll position.
        requestAnimationFrame(() => {
          const name = section.querySelector('[data-cm-partner-name]');
          if (name) name.focus({ preventScroll: true });
        });
      });
    });
    selectFromHash();
  };

  initialize();
  window.addEventListener('hashchange', selectFromHash);
  document.addEventListener('shopify:section:load', initialize);
})();
